import { useNavigate } from "react-router-dom"

const DarkBloc=()=>{
    const navigate=useNavigate()
return(
    <div className="dark-bg space-bloc">
        <div className="col-md-8  mx-auto">
            <h2 className="text-white text-center">Prêt à dynamiser votre activité et augmenter votre chiffre d’affaires ?</h2>
        <p className="body white66 mt-16 text-center">
        Twyny simplifie la gestion de vos rendez-vous et paiements, tout en vous aidant à développer votre activité. Concentrez-vous sur l'essentiel : la satisfaction de vos clients.
        </p> 
        <div className="text-center">
        <button className=" twyny-cta-primary mt-32" onClick={()=>navigate('/registerPrestataire')}>
              Découvrir gratuitement
            </button>   
        </div>
       
        </div>
       
    </div>
)
}
export default DarkBloc